import React from 'react';

/**
 * Loading rows (.ink-skel): grey bars where a section's rows will be, shown
 * until its data arrives so an empty state never flashes first.
 */
export function InkSkeleton({
  rows = 3,
  label = 'Loading',
  style,
}: {
  rows?: number;
  label?: string;
  style?: React.CSSProperties;
}) {
  return (
    <div className="ink-skel" role="status" aria-label={label} aria-busy="true" style={style}>
      {Array.from({ length: rows }, (_, i) => (
        <div className="ink-skel-row" key={i}>
          <span
            className="ink-skel-bar"
            data-size="lg"
            style={{ width: `${72 - (i % 3) * 14}%` }}
          />
          <span className="ink-skel-bar" style={{ width: `${44 - (i % 2) * 12}%` }} />
        </div>
      ))}
    </div>
  );
}

/**
 * A whole screen in grey bars — its title, a line under it, then rows — for
 * while the site itself is still loading and the screen can't draw yet (QA
 * round 7: Content and Account showed an empty page for seconds).
 */
export function InkPageSkeleton({ label = 'Loading' }: { label?: string }) {
  return (
    <div className="ink-body" role="status" aria-label={label} aria-busy="true">
      <div aria-hidden="true">
        <span
          className="ink-skel-bar"
          style={{ display: 'block', width: 220, height: 30, borderRadius: 8 }}
        />
        <span className="ink-skel-bar" style={{ display: 'block', width: 340, marginTop: 16 }} />
        <div className="ink-skel" style={{ marginTop: 36 }}>
          {[72, 58, 66, 48, 62].map((w, i) => (
            <div className="ink-skel-row" key={i}>
              <span className="ink-skel-bar" data-size="lg" style={{ width: `${w}%` }} />
              <span className="ink-skel-bar" style={{ width: `${w - 24}%` }} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
